export default "__VITE_ASSET__QgWZCNDa__"